import React, { useState, useEffect } from "react";

import { get } from "lodash";
import { Button,FormGroup, Label } from "reactstrap";

import {
  getUserNameFromPan,
} from "../../waitlist/services/waitlist-service";
import { toast, ToastContainer } from "react-toastify";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import moment from "moment";
// import { Mixpanel } from "../../waitlist/components/MixPanel";

export default function KycPANPreview(props) {
  const { setReupload } = props;
  const [name, setName] = useState("");
  const [tpdDetails, setTpdDetails] = useState({});

  useEffect(() => {
    setTpdDetails(props.userProfile);
    let pan = get(props.userProfile, "pan", "");
    if (pan) {
      getUserNameFromPan(pan, {"X-product": `orobonds:default`, "use-pkey" : false})
        .then((res) => {
          if (res && !res.success) {
            if (res.message === "PAN not unique") {
              toast.error(
                "Sorry, this PAN is already registered, please try another " +
                "PAN or contact connect@orowealth.com."
              );
            }
          }
          setName(get(res, "data.full_name", ""));
        })
        .catch((err) => {
          return toast.error("Unable to fetch user details for this PAN");
        });
    }
  }, [props.userProfile]);

  const getPanStatus = () => {
    if (props.isKycDone) {
      return <>
        <p className="mb-0 text-capitalize">
          PAN verified successfully
        </p>
        <img src={process.env.REACT_APP_IMAGES_PATH + "success.webp"} alt="success-icon"/>
      </>
    } else {
      return <>
        <p className="mb-0 text-capitalize">
          PAN verification is under process
        </p>
        <img src={process.env.REACT_APP_IMAGES_PATH + "Verification.webp"} alt="success-icon"/>
      </>
    }
  }

  const editPan = () => {
    setAnalyticsEvent(window.location.pathname + window.location.hash,
      "Postlogin_orobonds_docvault_PAN_Edit_Clicked"
    );
    // Mixpanel.track("cl_edit_pan_docvault");
    setReupload(true)
  }

  const getGender = () => {
    let genderMap = {
      "M": "Male",
      "F": "Female",
      "O": "Others",
    }
    return genderMap[tpdDetails.gender];
  }

  const getIncome = () => {
    let incomeMap = {
      "1": "Less than 1 lakh",
      "2": "1-5 lakh",
      "3": "5-10 lakh",
      "4": "10-25 lakh",
      "5": "More than 25 lakh"
    }
    return incomeMap[tpdDetails.income];
  }

  const getDob = (dt) => {
    let date;
    if ((dt?.split('T')[0])) {
      date = new moment(dt?.split('T')[0])?.format('DD/MM/YYYY')
      return date
    } else if (!(dt?.split('T')[0])){
      date = new moment(dt).format('DD/MM/YYYY')
      return date
    } else {
      date = "NA"
      return date
    }
  }

  return (
    <>
      <div className="pan-window">
        <div className="pan-status text-capitalize">
          {getPanStatus()}
        </div>

        <div className="pan-details border">
          <FormGroup className="display-user-details">
            <Label className="font-size-tiny text-muted">
              PAN No.
            </Label>
            <p>{props.panValue}</p>
            <Label className="font-size-tiny text-muted">
              Name
            </Label>
            <p>{name}</p>
            <Label className="font-size-tiny text-muted">DOB</Label>
            <p>{getDob(tpdDetails.dob)}</p>
            <Label className="font-size-tiny text-muted">Gender</Label>
            <p>{getGender()}</p>
            <Label className="font-size-tiny text-muted">Income</Label>
            <p>{getIncome()}</p>
          </FormGroup>
          <div className="btn-container">
            {!props.isKycDone && (
              <div className="submit" onClick={editPan}>
                <Button color="secondary" outline>Edit</Button>
              </div>
            )}
            <Button
              className="nxt"
              onClick={props.moveNextTab}
            >
              Next
            </Button>
          </div>
        </div>        
      </div>
      <ToastContainer />
    </>
  );
}
